<template>
  <div class="box1"style="background-color: #fff">
<!--      <div class="nav">-->
<!--        <button class="btn" @click="bk()">< 返回</button>-->
<!--        <span class="el-dropdown-link c1">-->
<!--        拜访查询<i class="el-icon-arrow-down el-icon&#45;&#45;right c2"></i>-->
<!--      </span>-->
<!--        <p class="c3">王晓燕</p>-->
<!--          <div style="width: 100%;height: 50px;background-color: #fff;line-height: 50px;text-align: center;">-->
<!--              <div style="color: #4D586D;position: relative">拜访查询<i class="el-icon-arrow-down el-icon&#45;&#45;right "></i>-->
<!--                  <div class="grid-content bg-purple " style="position: absolute;left: 10px;top: 0px;color: #FF9901">-->
<!--                      <span class="el-icon-arrow-left" @click="bk()">返回</span>-->
<!--                  </div>-->
<!--              </div>-->
<!--              <span style="position: relative;top:-31px;font-size: 13px;color: #B0B5B9;"> 王晓燕</span>-->
<!--          </div>-->
<!--      </div>-->
      <div class="btn1">
        <span class="el-icon-arrow-left dat1" @click="addBtn()"></span>
         <span class="dat3">{{dat}}年</span>
        <span class="el-icon-arrow-right dat2" @click="addBtn1()"></span>
      </div>
      <el-row style="margin-top: 20px">
        <el-col :span="12"><div class="grid-content bg-purple">
          <div class="d1">
              <p style="color: #fff;font-size: 14px;padding-top: 10px;padding-left: 10px ">本月有效拜访</p>
              <div style="padding: 5px 30px 5px 5px;display: flex;justify-content: space-between;align-items: flex-end">
                  <div>
                      <img src="../../assets/images/baifanga.png" alt="" width="50px" height="50px">
                  </div>
                  <div style="color: #fff;font-size: 22px;padding-bottom: 5px">
                      {{valid_call}} 次
                  </div>
              </div>
          </div>
        </div></el-col>
        <el-col :span="12"><div class="grid-content bg-purple">
          <div class="d2">
              <p style="color: #fff;font-size: 14px;padding-top: 10px;padding-left: 10px ">本月计划拜访</p>
              <div style="padding: 5px 30px 5px 5px;display: flex;justify-content: space-between;align-items: flex-end">
                  <div>
                      <img src="../../assets/images/rili.png" alt="" width="50px" height="50px">
                  </div>
                  <div style="color: #fff;font-size: 22px;padding-bottom: 5px">
                      {{plan_call}} 次
                  </div>
              </div>
          </div>
        </div></el-col>
      </el-row>
    <div id="char">
      <div id="myChat"></div>
    </div>

    </div>
</template>

<script>
import echarts from 'echarts'
import http from '../../APIService/http'
export default {
  name: "login4",
  components:{echarts},
  data(){
    return{
      dat:"",
      tenant_id: "1472813523",
      owner_id:"1123",
      title1:[],
      valid_call:"",
        plan_call:"",
      jihuabaifang: [],
      jihuaneibaifang: [],
      jihuawaibaifang: [],
      jihuawanchenglv: [],
    }
  },
  mounted() {
    let date=new Date;
    this.dat = date.getFullYear();
    this.nav();
  },
  methods:{
    bk(){

      this.$router.push({path:'/reportIndex'})
    },
    nav(){
      let that = this
      let myChart = echarts.init(document.getElementById('myChat'));
      let forms = {
        years:this.dat,
        tenant_id:this.tenant_id,
        owner_id:this.owner_id
      }
      that.jihuabaifang = []
      that.jihuaneibaifang = []
      that.jihuawaibaifang=[]
      that.jihuawanchenglv=[]
      that.title1=[]
      http.post('/wapi/gkGetFeedback/GkVisitQuery',forms).then(function (res){
        let v = res.data.data;
        that.valid_call=res.data.valid_call
        that.plan_call=res.data.plan_call
        for (let i=0;i<v.length;i++){
          let str=v[i].call_date.substring(4,6);
          if (str<'10'){
            let str=v[i].call_date.substring(5,6);
            that.title1.push(str+'月')
          }else{
            let str=v[i].call_date.substring(4,6);
            that.title1.push(str+'月')
          }
          that.jihuabaifang.push(Array(v[i].plan_call))
          that.jihuaneibaifang.push(Array(v[i].inside_the_plan_call))
          that.jihuawaibaifang.push(Array(v[i].outside_the_plan_call))
          that.jihuawanchenglv.push(Array(v[i].rate))

        }

        let ys = that.title1;
        let shi1 = that.jihuaneibaifang
        let shi2 = that.jihuawaibaifang
        let shi3 = that.jihuabaifang
        let shi4 = that.jihuawanchenglv
        let numbers1 = shi1.map(Number)
        let numbers2 = shi2.map(Number)
        let numbers3 = shi3.map(Number)
        let numbers4 = shi4.map(Number)
        let options={
          title:{
            text:'拜访统计',
          },
          color: ['#2CD0AC','#99f8e4','#FF9901','#efc48d'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
          },
          legend:{
            data:['实际拜访','计划拜访'],
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'value',
            }
          ],
          yAxis: [
            {
              type: 'category',
              data: ys,
            }
          ],
          series: [
            {
              name: '实际拜访',
              type: 'bar',
              stack: '实际拜访',
              data: numbers1
            },
            {
              name: '计划外拜访',
              type: 'bar',
              stack: '实际拜访',
              data: numbers2
            },
            {
              name: '计划拜访',
              type: 'bar',
              stack: '计划拜访',
              data: numbers3
            },
            {
              name: '计划完成率',
              type: 'bar',
              stack: '计划拜访',
              data: numbers4
            }
          ]
        };
        myChart.setOption(options);
        window.addEventListener('resize',function() {myChart.resize()});
      })
    },
    addBtn(){
      this.dat=parseInt(this.dat)-1;

      this.nav();
      console.log(this.dat)
    },
    addBtn1(){
      this.dat=parseInt(this.dat)+1;
      this.nav();
      console.log(this.dat)
    }
  },
}
</script>

<style >

  .dat3{
    margin: 33%;
    position: relative;
    color: orange;
  }
  .dat1,.dat2{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #dcdee0;
    padding: 3px 3px;
    color: white;
  }
  .dat1{
    float: left;
    margin-left: 10px;
  }
  .dat2{
    float: right;
    margin-right: 10px;
  }
  .el-card__body{
    padding: 0;
  }
  .d1{
    background-color: #2CD0AC;
    width: 100%;
    height: 100px;
  }
  .d2{
    background-color: #FF9901;
    width: 100%;
    height: 100px;
  }
  #myChat{
    width: 100%;
    height: 500px;
    margin: 0 auto;
    opacity: 0.8;
  }
  button{
    border: none;
    color: orange;
    background-color: white;
    margin: 10px 5px;
  }
  .nav{
    width: 100%;
    height: 50px;
    background-color: white;
  }
  .c1{
    margin-left: 80px;
    margin-top: 10px;
    position: absolute;
  }
  .c2{
    color: #b9afaf;
    margin-left: 3px;

  }
  .c3{
    color:  #b9afaf;
    font-size: 14px;
    position: absolute;
    margin-top: -10px;
    margin-left: 150px;
  }
  .btn1{
    width: 100%;
    margin: 0px auto;
      padding-top:10px ;
  }
</style>



// WEBPACK FOOTER //
// src/pages/gkReport/Visit.vue